import Area from '@/components/Area';
import { MantineProvider, Slider } from '@mantine/core';
import { Html, OrbitControls } from '@react-three/drei';
import { Canvas, useThree } from '@react-three/fiber';
import * as React from 'react';
import { Mesh } from 'three';
import { OrbitControls as OrbitControlsInstance } from 'three-stdlib';

function Box() {
  const [size, setSize] = React.useState(1);
  const controls = useThree((state) => state.controls as any as OrbitControlsInstance);
  // const ref = React.useRef<Mesh>(null);
  // console.log('Box', { controls });
  return (
    <mesh scale={size * 2}>
      <boxGeometry />
      <meshStandardMaterial color="orange" />
      <Html
        //
        // occlude="blending"
        // occlude
        // distanceFactor={1}
        position={[0, 0, size / 2 + 0.5]} // Adjusted to avoid z-fighting
        // position={[0, 0, 0.51]}
        transform
      >
        {/* <MantineProvider>
          <div css={{ border: '1px solid black', padding: '10px', display: 'flex', alignItems: 'center' }}>
            <span css={{ pointerEvents: 'none', userSelect: 'none' }}>Size</span>
            <Slider
              css={{ width: '100px' }}
              value={size}
              min={0.5}
              max={1}
              step={0.1}
              onChange={(valueNext) => {
                controls.enabled = false;
                setSize(valueNext);
              }}
              onChangeEnd={(valueNext) => {
                console.log('onChangeEnd', valueNext);
                controls.enabled = true;
              }}
            />
          </div>
        </MantineProvider> */}
        <div
          css={{
            border: '1px solid black',
            padding: '10px',
            backgroundClor: 'white',
          }}
        >
          <MantineProvider>
            <span css={{ pointerEvents: 'none', userSelect: 'none' }}>Size</span>
            <Slider
              value={size}
              min={0.5}
              max={1}
              step={0.01}
              onChange={(valueNext) => {
                controls.enabled = false;
                setSize(valueNext);
              }}
              onChangeEnd={(valueNext) => {
                console.log('onChangeEnd', valueNext);
                controls.enabled = true;
              }}
            />
          </MantineProvider>
        </div>
      </Html>
    </mesh>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  return (
    <Area>
      {() => (
        <>
          <Canvas camera={{ position: [2, 1, 5], fov: 25 }}>
            <ambientLight intensity={0.5} />
            <pointLight position={[10, 10, 5]} />
            <pointLight position={[-10, -10, -10]} />
            <Box />
            <OrbitControls makeDefault />
            <gridHelper />
          </Canvas>
        </>
      )}
    </Area>
  );
}

export default React.memo(App01);
